const ALLOWED_NON_NUMERIC_BASELINE_VALUES = new Set(['new metric']);
const ALLOWED_NON_NUMERIC_CURRENT_VALUES = new Set(['pending']);
const ALLOWED_NON_NUMERIC_FORECAST_VALUES = new Set(['n/a', 'na', 'pending']);

const toMetricValueText = (value?: string | null) => value?.trim() ?? '';

export const hasNumericMetricText = (value?: string | null) =>
  /-?(?:\d+\.?\d*|\.\d+)/.test(toMetricValueText(value).replace(/,/g, ''));

const hasNonNumericMetricText = (value?: string | null, allowedValues?: ReadonlySet<string>) => {
  const text = toMetricValueText(value);
  return Boolean(text) && !hasNumericMetricText(text) && !allowedValues?.has(text.toLowerCase());
};

export const hasInvalidMetricBaselineValue = (value?: string | null) =>
  hasNonNumericMetricText(value, ALLOWED_NON_NUMERIC_BASELINE_VALUES);

export const hasInvalidMetricCurrentValue = (value?: string | null) =>
  hasNonNumericMetricText(value, ALLOWED_NON_NUMERIC_CURRENT_VALUES);

export const hasInvalidMetricForecastValue = (value?: string | null) =>
  hasNonNumericMetricText(value, ALLOWED_NON_NUMERIC_FORECAST_VALUES);
